import React from 'react';
import { Box, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { getResponsiveSize } from '../../utils/responsive';
import globalStyles from '../../global';

const LeadersComp = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

  const components = [
    {
      icon: 'businessUnderstanding.png',
      title: 'Business Understanding',
    },
    {
      icon: 'roleofTech.png',
      title: 'Role of Technology in Laundry Business',
    },
    {
      icon: 'capitalRequirement.png',
      title: 'Capital Requirements',
    },
    {
      icon: 'importanceOf.png',
      title: 'Importance of Operations & Technical Training',
    },
    {
      icon: 'knowledge.png',
      title: 'Equipment Knowledge',
    },
  ];

  return (
    <Box
      sx={{
        mx: 'auto', // Center the box horizontally
        color: '#ffffff',
      }}
    >
      <Grid container spacing={isMobile ? 1 : 1.5} justifyContent="flex-start">
        {components.map((component, index) => (
          <Grid item xs={12} sm={6} md={6} key={index}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                borderRadius: 2,
                height: '100%', // Equal height for grid items
              }}
            >
              <Box sx={styles.box1}>
                <img
                  src={`${imageBaseUrl}${component.icon}`}
                  alt="business"
                  className="h-8 sm:h-10 md:h-12 lg:h-16 w-auto object-contain"
                />
              </Box>
              <Typography
                variant="regular_text_ur"
                sx={[styles.text1, { color: globalStyles.colors.army_green }]}
              >
                {component.title}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

const styles = {
  text1: {
     fontSize: {
              xs: "14px",
              md: "18px",
              lg: "18px",
            },
  },
  box1: {
    padding: {
      xs: getResponsiveSize(2.4 * 0.7),
      md: getResponsiveSize(2.4 * 0.8),
      lg: getResponsiveSize(2.4),
    },
    border: `1px solid ${globalStyles.colors.border_gray}`,
    borderRadius: '10px',
    marginRight: getResponsiveSize(1),
  },
};
export default LeadersComp;
